import React from 'react';
import { translateKeyLang } from '../../../../common/src/translate/translateHelper';
import { IWithReactRouterProps } from '../../mixins/router/withReactRouter';
import { fetchJson, fetchPost } from '../../store/fetch';
import { Roles } from '../../utils/enums/Roles';
import { appContext } from '../appContext';
import { Content, EditPanelButton, EditPanelButtons, EditPanelSection, EditPanelSelect, Panel, PanelBody, PanelHeader, Tray } from '../elements';
import { Component } from '../utils/Component';

interface ICompany {
    id: string;
    name: string;
}

interface IRelationAddState {
    companyId: string;
    selectedCompanyId?: undefined | string;
    selectedRole?: undefined | string;
    message?: undefined | string;
    submitting: boolean;
    failed: boolean;
    saved: boolean;
    errorCode?: undefined | string;
    companies: ICompany[];
}

export class CompanyRelationAdd extends Component<IWithReactRouterProps, IRelationAddState> {
    constructor(props: IWithReactRouterProps) {
        super(props);

        const state = {
            companyId: this.props.location.query.companyId,
            submitting: false,
            failed: false,
            saved: false,
            companies: [] as ICompany[],
            selectedRole: '',
        };
        this.state = state;
    }

    public override render() {
        return (
            <appContext.Consumer>
                {(state) => (
                    <Content>
                        <Tray>
                            <Panel small topBorder>
                                <form method="post" action="/" id="admin-form">
                                    <PanelBody>
                                        <PanelHeader text={translateKeyLang(state.languageCode, 'company.addRelation')} />
                                        <EditPanelSection>
                                            <EditPanelSelect
                                                name="selectedRole"
                                                value={this.state.selectedRole}
                                                handleChange={this.handleChange.bind(this)}
                                                disabled={this.state.submitting}
                                                placeholder={translateKeyLang(
                                                    state.languageCode,
                                                    'common.selectItem',
                                                    translateKeyLang(state.languageCode, 'common.role'),
                                                )}
                                                options={[
                                                    { value: Roles.Surveyor, text: translateKeyLang(state.languageCode, 'common.surveyor') },
                                                    { value: Roles.Operator, text: translateKeyLang(state.languageCode, 'common.operator') },
                                                    { value: Roles.Owner, text: translateKeyLang(state.languageCode, 'common.owner') },
                                                ]}
                                            />
                                        </EditPanelSection>

                                        {/* Company selection */}
                                        <EditPanelSection>
                                            <EditPanelSelect
                                                name="selectedCompanyId"
                                                value={this.state.selectedCompanyId}
                                                handleChange={this.handleChange.bind(this)}
                                                disabled={this.state.submitting}
                                                placeholder={translateKeyLang(
                                                    state.languageCode,
                                                    'common.selectItem',
                                                    translateKeyLang(state.languageCode, 'common.company'),
                                                )}
                                                options={this.state.companies.map((item: any) => {
                                                    return { value: item.id, text: item.name };
                                                })}
                                            />
                                        </EditPanelSection>
                                    </PanelBody>
                                    <EditPanelButtons footer>
                                        <EditPanelButton
                                            onClick={() => this.props.navigate(`/companies/${this.state.companyId}`)}
                                            text={translateKeyLang(state.languageCode, 'common.cancel')}
                                            small={false}
                                            disabled={this.state.submitting}
                                        />
                                        <EditPanelButton
                                            onClick={async () => this.saveClicked()}
                                            text={translateKeyLang(state.languageCode, 'common.save')}
                                            small={false}
                                            primary={true}
                                            disabled={
                                                this.state.submitting ||
                                                this.state.selectedCompanyId === undefined ||
                                                this.state.selectedCompanyId === ''
                                            }
                                        />
                                    </EditPanelButtons>
                                </form>
                            </Panel>
                        </Tray>
                    </Content>
                )}
            </appContext.Consumer>
        );
    }

    private async handleChange(value: any, stateKey: string) {
        const newState = {} as any;
        newState[stateKey] = value;
        await this.setState(newState);

        if (stateKey === 'selectedRole') {
            await this.loadCompanies(value);
        }
    }

    private async loadCompanies(role: string) {
        await this.setState({ submitting: true });
        const url = `/api/companyList?type=${role}`;
        await this.setState({ submitting: true });
        const result = await fetchJson(url, 'GET');
        if (result.successful) {
            const selectedCompanyId = result.json.items && result.json.items.length > 0 ? result.json.items[0].id : undefined;
            await this.setState({
                companies: result.json.items,
                selectedCompanyId: result.json.items && result.json.items.length > 0 ? selectedCompanyId : selectedCompanyId,
                failed: false,
                submitting: false,
            });
        } else {
            await this.setState({ submitting: false, failed: true, errorCode: result.errorCode });
        }
    }

    private async saveClicked() {
        await this.setState({ message: undefined, submitting: true, errorCode: undefined, failed: false });
        const url = '/api/companyRelations';
        const data = {
            managesId: this.state.selectedCompanyId,
            managedById: this.state.companyId,
        };
        await fetchPost(url, {}, data);
        this.props.navigate(`/companies/${this.state.companyId}?list=1`);
    }
}
